import React from "react";

interface BillingInfoIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const BillingInfoIcon: React.FC<BillingInfoIconProps> = ({ width = 32, height = 32, className = "" }) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#1E294F" />
    <g clipPath="url(#clip0_783_2630)">
      <path d="M16 7.66699V24.3337" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M20.1667 10.167H13.9167C13.1431 10.167 12.4013 10.4743 11.8543 11.0213C11.3073 11.5682 11 12.3101 11 13.0837C11 13.8572 11.3073 14.5991 11.8543 15.1461C12.4013 15.693 13.1431 16.0003 13.9167 16.0003H18.0833C18.8569 16.0003 19.5987 16.3076 20.1457 16.8546C20.6927 17.4016 21 18.1434 21 18.917C21 19.6905 20.6927 20.4324 20.1457 20.9794C19.5987 21.5264 18.8569 21.8337 18.0833 21.8337H11"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_783_2630">
        <rect width="20" height="20" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);

export default BillingInfoIcon;
